/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment } from "react";
import { shopContext } from "../../contexts/aniplus";
import { withRouter, Link } from "react-router-dom";
import axios from "axios";

import { toast } from "react-toastify"; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
import NumberFormat from "react-number-format";
import Email from "react-email-autocomplete";

class FindId extends Component {
  state = {
    part: "email",
    username: "",
    email: "",
    mobile: "",
    intReturn: 100,
  };
  _onChangePart = (e) => {
    //console.log(e.target.value)
    this.setState({
      part: e.target.value,
    });
  };

  _onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };
  _onFind = async () => {
    const { part, username, email, mobile } = this.state;
    const { onFindIdCode } = this.props.childProps;

    if (username === "" || username === null || username === undefined) {
      toast.warn("이름을 입력해 주세요.");
      return false;
    }
    if (part === "email") {
      if (email === "" || email === null || email === undefined) {
        toast.warn("가입시 등록한 email을 입력해 주세요.");
        return false;
      }
    }
    if (part === "mobile") {
      if (mobile === "" || mobile === null || mobile === undefined) {
        toast.warn("가입시 등록한 휴대폰 번호를 입력해 주세요.");
        return false;
      }
    }

    const result = await this._onFindApi();
    const intReturn = result.data[0].intReturn;
    let findId;
    if (intReturn === 0) {
      findId = result.data[0].listData[0].userid;
    } else {
      findId = "";
    }

    onFindIdCode(intReturn, findId, 0);
  };
  _onFindApi = () => {
    const { part, username, email, mobile } = this.state;
    const { apiUrl } = this.props;

    //console.log(part, username, email, mobile)
    //console.log(apiUrl + '/findAcount?part=' + part + '&username=' + username + '&email=' + email)

    //return axios(apiUrl + '/findAcount?part=' + part + '&username=' + username + '&email=' + email)

    return axios
      .post(apiUrl + "/findAcount", {
        params: {
          part: part,
          username: username,
          email: email,
          mobile: mobile,
        },
      })

      .then((response) => response)
      .catch((error) => {
        toast.error("계정정보를 확인중 오류가 발생했습니다.");
      });
  };
  render() {
    const { part, username, email, mobile } = this.state;
    const customDomains = [
      "naver.com",
      "nate.com",
      "gmail.com",
      "yahoo.com",
      "kakao.com",
    ];
    return (
      <Fragment>
        <div className="login_padding">
          <h1>
            아이디를 잊으셨나요?
            <span>가입시 입력하신 정보로 아이디를 찾으실 수 있습니다.</span>
          </h1>
          <div className="radio_btn">
            <div className="radio_group">
              <input
                id="radio1"
                type="radio"
                name="radio"
                value="email"
                checked={part === "email"}
                className="radiobox_img"
                onChange={this._onChangePart}
              />
              <label htmlFor="radio1">이메일주소</label>
            </div>
            <div className="radio_group">
              <input
                id="radio2"
                type="radio"
                name="radio"
                value="mobile"
                checked={part === "mobile"}
                className="radiobox_img"
                onChange={this._onChangePart}
              />
              <label htmlFor="radio2">휴대폰</label>
            </div>
          </div>

          <ul className="radius1">
            <li className="">
              <input
                name="username"
                type="text"
                className="common_input login_input"
                value={username}
                onChange={this._onChange}
                placeholder="이름"
              />
            </li>
            <li>
              {part === "email" ? (
                <Email
                  className="common_input login_input"
                  placeholder="Enter email"
                  domains={customDomains}
                  value={email}
                  onChange={this._onChange}
                />
              ) : (
                /*<input name="email" type="text" className="common_input login_input" value={email} onChange={this._onChange} placeholder="이메일"/>*/
                <NumberFormat
                  name="mobile"
                  format="###-####-####"
                  value={mobile}
                  className="common_input login_input"
                  placeholder="휴대폰(-없이 숫자만)"
                  onChange={this._onChange}
                />
              )}
            </li>
          </ul>
          <div className="login_id">
            위의 정보로 아이디 찾기가 불가능 하신가요?
            <br />
            <Link to="/customer/0">고객센터로</Link> 문의해 주세요.
            <br />
            TEL. 070-7162-7013
          </div>
          <div className="login_btn">
            <a style={{ cursor: "pointer" }} onClick={this._onFind}>
              {part === "email" ? "이메일로 찾기" : "휴대폰으로 찾기"}
            </a>
          </div>
        </div>

        {/*            
                <ToastContainer 
                    position="bottom-right"
                    hideProgressBar
                />
                */}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(FindId));
